var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-start flex-column",style:([
    {
      backgroundColor: '#F4F4F4',
      borderRadius: '0',
      padding: `48px ${_vm.$globalSideMargin}`,
      maxHeight: '703px',
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    _vm.$breakpoints.mdAndUp && {
      borderRadius: _vm.$getScaledCssValue('6px'),
      height: 'auto',
      padding: `${_vm.$getScaledCssValue('29px')} 4px ${_vm.$getScaledCssValue(
        '21px'
      )} 0`
    }
  ])},[(_vm.sidebarData)?[_c('div',{staticClass:"filter-item-label text-p3",style:({
                          marginLeft: _vm.$getScaledCssValue('22px'),
                          color:'#B38D3D',
                          fontWeight: 'bold',
                        })},[_vm._v(" Categories "),_c('div',{style:({
                      padding: `2px 0 0 10px`
                    })},_vm._l((_vm.sidebarData),function(item,index){return _c('Checkbox',{key:item.name + index,staticClass:"filter-checkbox checkbox",style:({
                        marginTop: '2px',
                        backgroundColor: '#f5f5f5'
                      }),attrs:{"val":item.name,"dense":"","color":"green","ripple":false},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"text-p5 d-flex font-weight-light"},[_vm._v(" "+_vm._s(item.name)+" "),_c('div',{style:({
                backgroundColor: '#50753611', 
                color: '#507536',        
                borderRadius: '6px',     /* Rounded corners */
                padding: '2px 8px',       /* Inner padding */
                marginLeft: '8px',        /* Spacing between name and count */
                fontWeight: 'bold',
                fontSize: '12px'          /* Adjust font size */
              })},[_vm._v(" "+_vm._s(item.count)+" ")])])]},proxy:true}],null,true),model:{value:(_vm.selectedSidebarItems),callback:function ($$v) {_vm.selectedSidebarItems=$$v},expression:"selectedSidebarItems"}})}),1)])]:_vm._l((6),function(n){return _c('SkeletonLoader',{key:n,style:({
        marginBottom: '2px',
        padding: `0 ${_vm.$getScaledCssValue('22px')}`
      }),attrs:{"data-cy":"list-sidebar-loader","type":"text"}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }